import * as React from 'react'
import { feeGroupMappings, getChildFeeGroupsFromAccountCategoryId } from '../../../ts/components/fees/feeGroupMappings'
import  FeesTable  from './FeesTable'
import * as _ from 'lodash'
import { MdTabs } from '../widgets'
import { translate } from 'react-translate'
import {
  updateClientExecutionFees, updateClientStorageFees, updateAccountExecutionFees,
  updateAccountStorageFees, deleteAccountExecutionFees, deleteAccountStorageFees,
  getFeesData, updateClientEwarrantFees
} from '../../api/fees'

import FeesConfirmation from './FeesConfirmation'
import FeesButtonGroup from './FeesButtonGroup'

const feesTableStyle = {
  marginBottom: '25px',
  marginTop: '-15px'
}

const commonTabStyle = {
  width: '100%'
}

class Fees extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    let feeTypes = (this.props.feeView === 'account' && !this.props.readOnly)
                    ? ['Execution Fees', 'Storage Fees']
                    : ['Execution Fees', 'Storage Fees', 'E-Warrant Fees']
    let feeGroup = getChildFeeGroupsFromAccountCategoryId(this.props.accountCategoryId)
    let feeGroupNames = _.map(feeGroup, feeGroupMappings)
    this.state = {
      feeView: this.props.feeView,
      accountCategoryId: this.props.accountCategoryId,
      fees: [],
      feeTypes: feeTypes,
      feeGroup: feeGroup,
      feeGroupNames: feeGroupNames,
      activeFeeType: feeTypes[0],
      activeClientType: feeGroupNames[0],
      activeMetalType: this.props.metals[0].id,
      isUsingDefaultFees: false,
      confirmationView: false,
      showSuccessConfirmation: false,
      errors: [],
      isEditing: false,
      timeoutEvent: null,
      ewarrantFeeType: 'Certification'
    }
  }
  public static defaultProps = {
    cancelActionFn: () => { },
    feeUpdateFn: () => { }
  }

  public componentDidMount() {
    return this.getData(
      this.state.activeFeeType,
      this.props.feeView,
      this.props.accountId,
      this.props.marketplaceId,
      this.state.activeClientType,
      this.state.ewarrantFeeType
    )
  }

  private dismissConfirmationView() {
    if (this.state.timeoutEvent) {
      clearTimeout(this.state.timeoutEvent)
    }
    this.setState({
      timeoutEvent: null,
      confirmationView: false,
      showSuccessConfirmation: false
    })
  }

  private setConfig(property, value) {
    this.dismissConfirmationView()
    this.setState({
      [property]: value,
    }, () => {
      this.getData(
        this.state.activeFeeType,
        this.props.feeView,
        this.props.accountId,
        this.props.marketplaceId,
        this.state.activeClientType,
        this.state.ewarrantFeeType
      )
    })
  }

  private async getData(
    activeFeeType: string,
    feeView: string,
    accountId: string,
    marketplaceId: number,
    activeClientType: string,
    ewarrantFeeType?: string
  ) {
    try {
      const data: any = await getFeesData(activeFeeType, feeView, accountId, marketplaceId, activeClientType, ewarrantFeeType)
      this.setState(data)
    } catch (error) {
      this.setState({
        fees: []
      })
      console.log('Get fees data error: ', error)
    }

  }

  private updateFees(index, tier, metalId, prop, contractId, newVal) {
    this.dismissConfirmationView()

    const fees = [...this.state.fees]
    const newFees = this.state.fees[index].map(fee => {
      if (fee.tier === tier && fee.metalId === metalId && (contractId === 0 || fee.contractId === contractId)) {
        fee[prop] = newVal
      }
      return fee
    })
    fees[index] = newFees

    this.setState({
      fees: fees,
      isEditing: true
    })
  }

  private updateData(
    feesId: number,
    accountId: string,
    marketplaceId: number,
    childAccountType: string
  ) {
    const fees: any = [... this.state.fees[feesId]]

    if (this.state.activeFeeType === 'Execution Fees' && this.props.feeView === 'client') {
      return updateClientExecutionFees(accountId, marketplaceId, childAccountType, fees)

    } else if (this.state.activeFeeType === 'Storage Fees' && this.props.feeView === 'client') {
      return updateClientStorageFees(accountId, marketplaceId, childAccountType, fees)

    } else if (this.state.activeFeeType === 'Execution Fees' && this.props.feeView === 'account') {
      return updateAccountExecutionFees(accountId, marketplaceId, fees)

    } else if (this.state.activeFeeType === 'Storage Fees' && this.props.feeView === 'account') {
      return updateAccountStorageFees(accountId, marketplaceId, fees)
    } else if (this.state.activeFeeType === 'E-Warrant Fees' && this.props.feeView === 'client') {
      return updateClientEwarrantFees(accountId, marketplaceId, childAccountType, fees, this.state.ewarrantFeeType)

    }

  }

  private async deleteData(
    activeFeeType: string,
    accountId: string,
    marketplaceId: number
  ) {
    if (activeFeeType === 'Execution Fees' && this.props.feeView === 'account') {
      await deleteAccountExecutionFees(accountId, marketplaceId)

    } else if (activeFeeType === 'Storage Fees' && this.props.feeView === 'account') {
      await deleteAccountStorageFees(accountId, marketplaceId)
    }
    this.getData(
      this.state.activeFeeType,
      this.props.feeView,
      this.props.accountId,
      this.props.marketplaceId,
      this.props.activeClientType,
      this.state.ewarrantFeeType
    )
  }

  private updateEwarrantFeeType(feeType) {
    this.setConfig('ewarrantFeeType', feeType)
  }

  private filterDisplayedFees(feeGroup) {
    let shouldShowSingleTierMatrix = [
      { feeView: 'client', activeClientType: 'Private Client', activeFeeType: 'Execution Fees' },
      { feeView: 'client', accountCategoryId: AccountCategories.introducingBroker },
      { feeView: 'account', accountCategoryId: AccountCategories.individualPrivateClient },
      { feeView: 'account', accountCategoryId: AccountCategories.companyPrivateClient },
      { feeView: 'account', accountCategoryId: AccountCategories.trustPrivateClient },
      { feeView: 'account', accountCategoryId: AccountCategories.smsfPrivateClient },
      { feeView: 'account', accountCategoryId: AccountCategories.sdiraPrivateClient }
    ]
    let evaluateSingleTierMatrix = (state): boolean => {
      return _.some(shouldShowSingleTierMatrix, (combination) => {
        return _.every(combination, (value, property) => {
          return state[property] === value
        })
      })
    }
    return _.filter(feeGroup, (fee: any) => {
      if (evaluateSingleTierMatrix(this.state) && fee.tier !== 1) {
        return false
      }
      if (this.state.activeFeeType === 'Storage Fees') {
        return fee.metalId === Number(this.state.activeMetalType)
      }
      return true
    })
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({
      accountId: nextProps.accountId,
      accountCategoryId: nextProps.accountCategoryId,
      marketplaceId: nextProps.marketplaceId,
      feeView: nextProps.feeView,
      metals: nextProps.metals
    })
    return this.getData(
      this.state.activeFeeType,
      this.props.feeView,
      this.props.accountId,
      this.props.marketplaceId,
      this.props.activeClientType,
      this.state.ewarrantFeeType
    )
  }

  private feeTypeTab() {
    if (this.state.activeFeeType === 'Execution Fees' || this.state.activeFeeType === 'E-Warrant Fees') {
      return (
        (this.props.feeView !== 'account') ?
          <MdTabs key='executionFeesTab' tabs={
            _.map(this.state.feeGroupNames, (groupName) => {
              return {
                content: groupName,
                handleClick: () => this.setConfig('activeClientType', groupName)
              }
            })
          } activeTab={this.state.activeClientType} tabStyle={commonTabStyle} />
          : null
      )
    } else if (this.state.activeFeeType === 'Storage Fees') {
      return (
        <MdTabs key='storageFeesTab' tabs={
          _.map(this.props.metals, (metal: any) => {
            return {
              content: metal.name,
              handleClick: () => this.setConfig('activeMetalType', metal.id)
            }
          })
        } activeTab={this.props.metals.find(metal => metal.id === this.state.activeMetalType).name}
          tabStyle={commonTabStyle} />
      )
    } else {
      return null
    }
  }

  public render() {
    let t = this.props.t
    const isEwarrantFees = this.state.activeFeeType === 'E-Warrant Fees'
    return (
      <div>
        <div>
          {
            <MdTabs tabs={
              _.map(this.state.feeTypes, (feeType) => {
                return {
                  content: feeType as string,
                  handleClick: () => this.setConfig('activeFeeType', feeType)
                }
              })
            } activeTab={this.state.activeFeeType} tabStyle={commonTabStyle} />
          }
        </div>
        <div>
          {
            this.feeTypeTab()
          }
        </div>
        <div>
          {_.map(this.state.fees, (feeGroup: ExecutionFee, id: number) => {
            const filteredFees = isEwarrantFees ? feeGroup : this.filterDisplayedFees(feeGroup).slice(0, 5)
            const accountId = isEwarrantFees ? this.props.accountId : feeGroup[0].accountId

            const [accountTypeName, marketplaceId, fees] = [
              feeGroupMappings(feeGroup[0].childAccountType),
              feeGroup[0].marketplaceId,
              filteredFees
            ]

            return (
              <div key={id + ':' + Date.now()}>
                <FeesTable
                  tableStyle={feesTableStyle}
                  fees={fees}
                  key={id}
                  updateFees={this.updateFees.bind(this)}
                  feeGroupIndex={id}
                  readOnly={this.props.readOnly}
                  ewarrantFees={isEwarrantFees}
                  activeEwarrantFeeType={this.state.ewarrantFeeType}
                  changeEwarrantFeeType={(feeType) => this.updateEwarrantFeeType(feeType)}
                />
                {this.props.readOnly ? null : (
                  () => {
                    if (!this.state.confirmationView) {
                      return (
                        <FeesButtonGroup
                          key={Math.random()}
                          handleResetButton={() => {
                            this.setState({
                              confirmationView: true,
                              confirmationApproved: () => {
                                return this.deleteData(this.state.activeFeeType, accountId, marketplaceId)
                              }
                            })
                          }}
                          handleCancelButton={() => {
                            this.getData(
                              this.state.activeFeeType,
                              this.props.feeView,
                              this.props.accountId,
                              this.props.marketplaceId,
                              this.state.activeClientType,
                              this.state.ewarrantFeeType
                            )
                            this.props.cancelActionFn()
                          }}
                          handleUpdateButton={() => {
                            if (this.state.isEditing) {
                              this.setState({
                                confirmationView: true,
                                confirmationApproved: () => {
                                  return this.updateData(id, accountId, marketplaceId, feeGroup[0].childAccountType)
                                }
                              })
                            }
                          }}
                          feeView={this.props.feeView}
                          isUsingDefaultFees={this.state.isUsingDefaultFees}
                        />
                      )
                    } else {
                      return <FeesConfirmation handleConfirm={async () => {
                        this.setState({ errors: [] })
                        try {
                          await this.state.confirmationApproved()
                          this.setState({
                            showSuccessConfirmation: true,
                            isEditing: false
                          }, () => {
                            this.getData(
                              this.state.activeFeeType,
                              this.props.feeView,
                              this.props.accountId,
                              this.props.marketplaceId,
                              this.state.activeClientType,
                              this.state.ewarrantFeeType
                            )
                            this.props.feeUpdateFn()

                            const timeoutEvent = setTimeout(() => {
                              this.setState({
                                confirmationView: false,
                                showSuccessConfirmation: false
                              })
                            }, 4000)
                            this.setState({
                              timeoutEvent: timeoutEvent
                            })
                          })
                        } catch (error) {
                          this.setState({
                            errors: error.response.data.errors
                          })
                        }
                      }} handleCancel={() => {
                        this.setState({
                          confirmationView: false,
                          errors: []
                        }, this.getData.bind(this,
                          this.state.activeFeeType,
                          this.props.feeView,
                          this.props.accountId,
                          this.props.marketplaceId,
                          this.state.activeClientType,
                          this.state.ewarrantFeeType
                        ))
                      }} errors={this.state.errors} showSuccess={this.state.showSuccessConfirmation} />
                    }
                  }
                )()}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default translate('Fees')(Fees)



// WEBPACK FOOTER //
// ./react/components/presentations/Fees.tsx